module.exports = __webpack_public_path__ + "img/OBM IDEA Lab_Aug 2021_375x506.d074e368.jpeg";